import * as React from 'react';

import { EHeatingType } from '../../../../../../../json_query';
import { getArrayChange } from '../../../../../../../utils/arrayChange';
import { DropdownField } from '../../../components/dropdownField';

export interface IHeatingProps {
  value: EHeatingType[];
  onChange(type: EHeatingType, value: boolean | undefined): void;
}

interface IHeating {
  label: string;
  value: EHeatingType;
}

const VALUES: IHeating[] = [
  { label: 'Центральное газовое', value: EHeatingType.Gas },
  { label: 'Угольное', value: EHeatingType.Coal },
  { label: 'Печь', value: EHeatingType.Furnace },
  { label: 'Камин', value: EHeatingType.Fireplace },
  { label: 'Электрическое', value: EHeatingType.Electric },
  { label: 'Автономное газовое', value: EHeatingType.AutonomousGas },
  { label: 'Дизельное', value: EHeatingType.Diesel },
  { label: 'Твердотопливный котел', value: EHeatingType.SolidFuelBoiler },
  { label: 'Не отапливается', value: EHeatingType.None },
];

export const Heating: React.StatelessComponent<IHeatingProps> = ({ value, onChange }) => (
  <DropdownField
    multiple
    placeholder="Любой"
    value={value.concat()}
    onValueChange={(types: EHeatingType[]) => onChange(...getArrayChange(value, types))}
    values={VALUES}
  />
);
